export { default as en } from './data/en.language';
export { default as tr } from './data/tr.language';
export { default as ar } from './data/ar.language';
export { default as bn } from './data/bn.language';
